module.exports = __webpack_public_path__ + "static/media/cart-fill.5cfb2292.svg";